import React from "react";

import { BiHome } from "react-icons/bi";
import { PiBuildingApartment } from "react-icons/pi";
import { BiBuildingHouse } from "react-icons/bi";
import { BsHouses } from "react-icons/bs";
import { BsBuildings } from "react-icons/bs";
import { TbStairsDown } from "react-icons/tb";
import { GiTreehouse } from "react-icons/gi";
import { useStateContext } from "../contexts/ContextProvider";

const PropertiesCard = (props) => {
  const { properties, handleModal, setCurrentPropertyId } = props;
  const { user, rooms, leases } = useStateContext();

  const getIcon = (homeType) => {
    if (homeType === "house") return <BiHome />;
    if (homeType === "apartment") return <PiBuildingApartment />;
    if (homeType === "condo") return <BiBuildingHouse />;
    if (homeType === "townhouse") return <BsHouses />;
    if (homeType === "loft") return <BsBuildings />;
    if (homeType === "basement") return <TbStairsDown />;
    if (homeType === "tiny house") return <BiHome />;
    if (homeType === "other") return <GiTreehouse />;
  };

  return (
    <div className="w-full md:max-w-[700px] mt-2 px-2 z-0">
      <ul className="w-full border-gray-300 border-1 rounded-xl overflow-y-auto mt-2 p-2">
        {properties.map((item, index) => {
          return (
            <li
              key={item.id}
              onClick={() => {
                handleModal("manageProperty");
                setCurrentPropertyId(item.id);
              }}
              className={`border-gray-400 border-2
               hover:border-snappily-orange rounded-md cursor-pointer p-1 m-1 ${
                 user.hasPublished
                   ? ""
                   : "animate-border-pulse hover:animate-none"
               }`}
            >
              <div className="flex ">
                <div className="grid justify-items-center">
                  <div
                    className={`bg-gray-200
                      ${
                        item.homeType === "tiny house"
                          ? "text-4xl px-8 py-6"
                          : "text-6xl  py-3 px-5"
                      }`}
                  >
                    {getIcon(item.homeType)}
                  </div>
                  <div className="text-lg pt-1">
                    {item.homeType[0].toUpperCase() + item.homeType.slice(1)}
                  </div>
                </div>
                <div className="pl-3 w-full ">
                  <div className="h-20 ">
                    <div
                      className="text-xl hover:text-blue-500 capitalize hover:underline"
                      onClick={() => {
                        handleModal("manageProperty");
                        setCurrentPropertyId(item.id);
                      }}
                    >
                      {item.street.length >= 40
                        ? item.street.slice(0, 38) + "..."
                        : item.street}
                    </div>
                    <div className="text-gray-400 capitalize">
                      {item.city + ", " + item.state}
                    </div>
                  </div>
                  <div className="flex w-full relative mt-2.5">
                    <div className="w-20">
                      Rooms:{" "}
                      <span className="text-snappily-orange">
                        {rooms.filter((x) => x.propertyId === item.id).length}
                      </span>
                    </div>
                    <div className="flex ml-10">
                      <div>Tenants:</div>
                      <span className="text-snappily-orange ml-1">
                        {leases.filter((x) => x.propertyId === item.id).length}
                      </span>
                    </div>
                    {/* <div className="absolute right-5 justify-end bg-gray-300 rounded-lg ml-2 px-1">
                      Draft
                    </div> */}
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PropertiesCard;
